import React from 'react';
import axios from 'axios';
const AuthCtx = React.createContext();

const evaluateAuth = (setAuth) => {
    return function(to, from, next) {
        axios.post('/api/validateToken')
            .then(resp => {
                console.log('success validate token')
                console.log(resp)
                if (resp.status === 200) {
                    setAuth({
                        token: resp.data.token
                    })
                    next()
                } else {
                    next.redirect('/login')
                }
            })
            .catch(err => {
                console.log('error validate token')
                console.log(err)
                next.redirect('/login')
            })
    }
}

export {
    AuthCtx as default,
    evaluateAuth
}